(function () {
  /* Collection comparison tables: labels, price column, variant sub-line,
     phone cards and scroll hint. Styling lives in assets/ou-collection-tables.css. */
  var WIDE = 26; /* values longer than this take the full card width on phones */

  function textOnly(el) {
    /* Return the element whose text we can safely restyle: the cell itself,
       or a single link inside it. Anything more complex is left untouched. */
    if (el.children.length === 0) return el;
    if (el.children.length === 1 && el.children[0].tagName === 'A' && el.children[0].children.length === 0) return el.children[0];
    return null;
  }

  function span(cls, text) {
    var s = document.createElement('span');
    s.className = cls;
    s.textContent = text;
    return s;
  }

  function enhance(table) {
    if (table.getAttribute('data-ou') === '1') return;
    table.setAttribute('data-ou', '1');

    var wrap = table.parentElement;
    if (!wrap || wrap.tagName !== 'DIV' || wrap.children.length !== 1 || wrap.classList.contains('faq-block')) {
      wrap = document.createElement('div');
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
    }
    wrap.classList.add('ou-tw');

    var hint = document.createElement('p');
    hint.className = 'ou-hint';
    hint.setAttribute('aria-hidden', 'true');
    hint.textContent = 'Scroll sideways to see every column →';
    wrap.parentNode.insertBefore(hint, wrap.nextSibling);

    var ths = table.querySelectorAll('thead th');
    var heads = Array.prototype.map.call(ths, function (th) { return th.textContent.trim(); });
    var rows = Array.prototype.slice.call(table.querySelectorAll('tbody tr'));

    if (heads.length && rows.length) {
      /* Price column: the last column when most of its cells read "From $..." */
      var last = heads.length - 1;
      var priced = rows.filter(function (r) {
        var c = r.children[last];
        return c && /^\s*From\s+\$/i.test(c.textContent);
      }).length;
      var priceCol = priced >= Math.ceil(rows.length / 2) ? last : -1;
      if (priceCol > -1) {
        ths[priceCol].classList.add('ou-price');
        table.classList.add('has-price');
      }

      rows.forEach(function (row) {
        var pos = 0, prev = null;
        Array.prototype.forEach.call(row.children, function (cell, i) {
          if (heads[i] && !cell.hasAttribute('data-label')) cell.setAttribute('data-label', heads[i]);
          var t = textOnly(cell);
          var txt = cell.textContent.trim();
          var m;

          if (i === 0) {
            /* "EDIC Galaxy 2000 (SX, IX, CX)" -> name + quieter variant line */
            if (t && (m = t.textContent.match(/^(.*?)\s*\(([^()]+)\)\s*$/))) {
              t.textContent = m[1];
              t.appendChild(span('ou-sub', m[2]));
            }
            return;
          }

          if (i === priceCol) {
            cell.classList.add('ou-price');
            if (t && (m = t.textContent.match(/^\s*From\s+(.+)$/i))) {
              t.textContent = '';
              t.appendChild(span('ou-from', 'From'));
              t.appendChild(span('ou-amt', m[1].trim()));
            }
            return;
          }

          if (/^see product page$/i.test(txt)) cell.classList.add('ou-gap');

          /* Parentheticals inside values become secondary text */
          if (t && /\([^()]+\)/.test(t.textContent)) {
            var parts = t.textContent.split(/(\([^()]+\))/);
            t.textContent = '';
            parts.forEach(function (p) {
              if (!p) return;
              if (/^\(.*\)$/.test(p)) t.appendChild(span('ou-note', p));
              else t.appendChild(document.createTextNode(p));
            });
          }

          /* Phone card grid: two tiles per line, long values take the line */
          if (txt.length > WIDE) {
            if (pos === 1 && prev) prev.classList.add('ou-span');
            cell.classList.add('ou-span');
            pos = 0;
          } else {
            pos = (pos + 1) % 2;
          }
          prev = cell;
        });
        if (pos === 1 && prev) prev.classList.add('ou-span');
      });

      table.classList.add('ou-cards');
      wrap.classList.add('ou-cards-wrap');
    }

    function check() {
      /* Card layout on phones never scrolls sideways */
      var cards = table.classList.contains('ou-cards') && getComputedStyle(table).display === 'block';
      wrap.classList.toggle('is-scroll', !cards && wrap.scrollWidth > wrap.clientWidth + 1);
    }
    check();
    window.addEventListener('resize', check);
    window.addEventListener('load', check);
  }

  function run() {
    document.querySelectorAll('.collection-content-below .faq-block table').forEach(enhance);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.ouEnhanceTables = run;
})();
